module.exports = __webpack_public_path__ + "img/u22.11b39079.jpg";